import React from 'react';
import './Header.css';

function Header() {
    return (
        <div className="row">
            <div className="col-12 header">
                <h1 className="h1">Strong password generator</h1>
                <div className="col-md-12">
                    <h4>Create strong password with password generator</h4>
                </div>
            </div>
        </div>
    )
}

export default Header